import fetchStompunkter from './fetchStompunkter'
import * as nät from '../constants/nat'

export default async function fetchLightStompunkter(bounds, filter) {
	return fetchStompunkter({
		path: 'filter',
		query: {
			includeForstorda: filter.förstörda,
			nat: visibleNät(filter),
		},
		body: body(bounds, filter)
	})
}

function visibleNät(filter) {
	let visible = []
	if (filter.riksavvägningen) {
		visible.push(nät.HÖJD)
	}
	if (filter.sweref) {
		visible.push(nät.PLAN)
	}
	if (filter.rix95) {
		visible.push(nät.PLAN)
	}
	return visible.join(',')
}

function body(bounds, filter) {
	return {
		geometri: {
	    	type: "Polygon",
	    	crs: {
	    		type: "name",
	    		properties: {
	    			name: "urn:ogc:def:crs:EPSG::3006"
	    		}
	    	},
	    	coordinates: [
	        	[
		            [bounds.west, bounds.north],
		            [bounds.west, bounds.south],
		            [bounds.east, bounds.south],
		            [bounds.east, bounds.north],
		            [bounds.west, bounds.north]
	        	]
	    	]
	   },
	   buffer: 0
	}
}



// WEBPACK FOOTER //
// ./src/dataSource/fetchLightStompunkter.js